import(/* webpackMode: "eager", webpackExports: ["AppShell"] */ "/app/src/components/layout/AppShell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductsPage"] */ "/app/src/components/pages/ProductsPage.tsx");
